export const PAGE_URLS = {
  HOME: "/",
  TOKEN_DISTRIBUTOR: "/",
  ADMIN: "/admin",
  CREATE_TOKEN_DISTRIBUTION: "/admin/create",
  DISTRIBUTE_TOKENS: "/admin/distribute",
  SHOPKEEPER: "/admin/buy",
}
